<template>
   <d-container fluid class="main-content-container px-4">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
         <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
            <span class="text-uppercase page-subtitle">Components</span>
            <h3 class="page-title">Create Staff</h3>
         </div>
      </div>
      <d-col lg="10" md="12">
         <d-card class="card-small mb-3">
            <d-card-body>
               <d-form>
                  <d-row>
                     <!-- First Name -->
                     <d-col md="6" class="form-group">
                        <label for="feFirstName">First Name</label>
                        <d-form-input type="text" id="feFirstName" placeholder="First Name" v-model="firstName"/>
                     </d-col>
                     <!-- Last Name -->
                     <d-col md="6" class="form-group">
                        <label for="feLastName">Last Name</label>
                        <d-form-input type="text" id="feLastName" placeholder="Last Name" v-model="lastName"/>
                     </d-col>
                  </d-row>
                  <div class="form-group">
                     <label>Email: </label>
                     <d-input id="email" type="email" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Email" v-model="Email"/>
                  </div>
                  <div class="form-group">
                     <label>Password: </label>
                     <d-input id="password" type="password" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Password" v-model="Password"/>
                  </div>
                  <div>
                     <label>Role: </label>
                     <d-checkbox v-model="selected" v-for="roles in role" :value="roles.id" :key="roles.id">{{ roles.roleName }}</d-checkbox>
                  </div>
                  <d-button theme="primary" @click="create()">Create</d-button>
               </d-form>
            </d-card-body>
         </d-card>
      </d-col>
   </d-container>
</template>
<script>
   import axios from "axios";
   import { sha256, sha224 } from 'js-sha256';
   
   export default {
       data() {
           return {
             firstName: "",
             lastName: "",
             Email: "",
             Password: "",
             role: [],
             selected: [],
             showModal: false,
           }
       },
       mounted: function () {
           axios
             .get(
               process.env.VUE_APP_SERVICE_URL+"api/admin/Role"
             )
             .then((response) => {
               this.role = response.data.result;
             })
             .catch(function (error) {
               console.log(error);
             });
       },
       methods: {
            create() {
              let pwd = sha256(this.Password);
              axios
               .post(process.env.VUE_APP_SERVICE_URL+'api/admin/User/public_user',{
                 email: this.Email,
                 password: pwd,
                 roleIds: this.selected
               })
                .then(response => {
                  console.log(response);
                })
               .catch(function (error) {
                 console.log(error);
               });
           },
       }
   };
</script>